import { render } from "./EventList.vue?vue&type=template&id=e7b4c812&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=e7b4c812&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e7b4c812"

export default script